import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from '@maui/elements'
import TimePickerBox from './TimePickerBox'

const createPaddedArray = (size, itemSize, padChar) =>
  [...new Array(size)].map((_, i) => (i + 1).toString().padStart(itemSize, padChar))

export default function TimePicker({ onChange, stateCheckedObject }) {
  const timers = createPaddedArray(24, 2, 0)

  const showLabel = ['01', '06', '12', '18', '24']
  return (
    <Box marginBottom="spaceGapXLarge">
      <Text as="label" fontSize="10px" fontWeight="600" display="block" marginBottom="4px">
        Click To Select Your Hours of Availability
      </Text>
      <Box display="flex" flexDirection="row" flexWrap="nowrap">
        {timers.map((t) => {
          return (
            <TimePickerBox key={`time${t}`} value={t} showLabel={showLabel.includes(t)} onChange={onChange} checked={stateCheckedObject[`${t}:00`]}/>
          )
        })}
      </Box>
    </Box>
  )
}

TimePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  stateCheckedObject: PropTypes.object,
}
